import * as yup from 'yup';

export const ssnValidation = yup
  .string()
  .nullable()
  .required('Social security number is required')
  // eslint-disable-next-line func-names
  .test('SSN-is-valid', 'You must enter a valid social security number', function(value) {
    if (!value) {
      // Let the .required() test handle it
      return true;
    }

    return !(value.replace(/-/g, '').length < 9);
  });
